import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

/**
 * The design's `.row-actions button` — the quiet affordance at the end of a
 * table row.
 *
 * It replaces the full outline button that several lists repeated down every
 * row: at twenty rows a bordered "Detail" twenty times over is the loudest
 * thing on the screen, and it is the same word twenty times.
 *
 * Unlike the design file these do not appear only on hover. AppTable's own
 * note explains why: this is an internal tool whose users run the same three
 * actions dozens of times a day, and an affordance that has to be discovered
 * reads as no affordance at all.
 */
const action = css`
  display: grid;
  place-items: center;
  width: var(--h-btn-sm);
  height: var(--h-btn-sm);
  padding: 0;
  border: none;
  border-radius: var(--r-sm);
  background: none;
  color: var(--text-faint);
  cursor: pointer;
  transition:
    background-color 0.12s,
    color 0.12s;

  &:hover {
    background: var(--line);
    color: var(--text);
  }

  svg {
    width: 15px;
    height: 15px;
    stroke-width: 1.8;
  }
`;

export const ActionLink = styled(Link)`
  ${action}
`;

export const ActionButton = styled.button`
  ${action}
`;
